import { useMediaQuery } from 'react-responsive'

const DefaultDevice = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 481 })
    return isNotMobile ? children : null
}

const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 480 })
    return isMobile ? children : null
}

const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }

function useDesktopOrLaptop() {
    return useMediaQuery({
        query: '(min-device-width: 1224px)'
    })
}

function useBigScreen() { return useMediaQuery({ query: '(min-device-width: 1824px)' }) }
function useTabletOrMobile() { return useMediaQuery({ query: '(max-width: 1224px)' }) }
function useTabletOrMobileDevice() {
    return useMediaQuery({
        query: '(max-device-width: 1224px)'
    })
}
function usePortrait() { return useMediaQuery({ query: '(orientation: portrait)' }) }
function useRetina() { return useMediaQuery({ query: '(min-resolution: 2dppx)' }) }
function useMobile() { return useMediaQuery({ query: '(max-width: 480px)' }) }
function useSmallScreen() {
    return useMediaQuery({
        query: '(min-device-width: 481px)'
    })
}

export {
    useDesktopOrLaptop,
    useBigScreen,
    useTabletOrMobile,
    useTabletOrMobileDevice,
    usePortrait,
    useRetina,
    useMobile,
    useSmallScreen,
    Mobile,
    DefaultDevice,
    Tablet
}